import styled, { StyledProps } from 'styled-components'

type Props = StyledProps<{
  disabled?: boolean
  invalid?: boolean
  inputSize?: 'thin' | 'small' | 'medium' | 'big'
}>
export const dynamicInputCss = ({ disabled, theme, invalid, inputSize }: Props) => {
  let opacity = 1
  let color = theme.color.onPrimaryDark
  let borderColor = theme.color.onSurfaceLowEmphasys
  let cursor
  let height
  if (disabled) {
    opacity = 0.5
    cursor = 'not-allowed'
  }

  if (invalid) {
    color = theme.color.accentDestructive
    borderColor = theme.color.accentDestructive
  }

  switch (inputSize) {
    case 'thin':
      height = '28px'
      break
    case 'small':
      height = '32px'
      break
    case 'medium':
      height = '40px'
      break
    case 'big':
      height = '48px'
      break
    default:
      height = '40px'
  }

  return {
    opacity,
    color,
    borderColor,
    cursor,
    height,
  }
}
export const focusInputCss = ({ invalid, theme }: Props) => {
  let borderColor = theme.color.primary600
  let color = theme.color.onPrimaryDark
  const borderWidth = '1px'
  if (invalid) {
    borderColor = theme.color.accentDestructive
    color = theme.color.accentDestructive
  }

  return {
    borderColor,
    color,
    borderWidth,
  }
}

export const hoverInputCss = ({ invalid, theme }: Props) => {
  let borderColor = theme.color.onPrimaryMid
  if (invalid) {
    borderColor = theme.color.accentDestructive
  }

  return {
    borderColor,
  }
}

export const InputStyled = styled.input<Props>`
  height: 40px;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 10px;
  box-sizing: border-box;
  outline: none;
  transition: 0.3s all;
  position: relative;

  /* hack for Safari's autofill icon so  that it won't interfere with our Eye icon */
  &::-webkit-credentials-auto-fill-button {
    position: relative;
    right: -35px;
  }

  /* hack to hide browser's auto-filled inputs background */
  box-shadow: 0 0 0 2em ${props => props.theme.color.onPrimaryLight} inset;

  &:hover {
    ${hoverInputCss}
  }

  &:read-only {
    cursor: not-allowed;
  }

  &:not(:read-only):focus {
    ${focusInputCss}
  }

  ${props => props.theme.media.mobile`
    font-size: 16px;
  `}

  ${dynamicInputCss}
`

export const InputError = styled.div<StyledProps<{}>>`
  color: ${props => props.theme.color.accentDestructive};
  margin-top: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`
